module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var uS = require('UserService.js').default;
   var u = require('util/Util.js').default;
   var typeUsr = uS.getUserType();
   var constants = require('Constants.js').default; 
   var listService = require('ListService').default;

   var isBULicense = u.isTrue(listService.accountSettings.IsBULicense);

   var enableReports = optionName === "Report" && isBULicense ? u.isTrue(uS.checkFeatures('Report')) : true;
   var enableWSSource = isBULicense ? u.isTrue(uS.checkFeatures('WSSource')) : true;
   let showButtonMenu = '';
   if (this.model.get('selectedTab') === "settings" && !u.isTrue(uS.checkPermissions("users")) && !u.isTrue(uS.checkPermissions("account"))){
        showButtonMenu = 'hidden';
   }
 
    ; __append("\r\n<style>\r\n    .pf-ui-state-hover{\r\n        background-color: #cfe2a8!important;\r\n    }\r\n\r\n    .bg-success {\r\n        background: linear-gradient(var(--gradient-ToBottom));\r\n        padding: 2px;\r\n    }\r\n\r\n    .bg-success h5, .bg-success i{\r\n       color: #ffffff!important;\r\n    }\r\n\r\n    .bg-success a{\r\n        padding: 2px 5px 0 0;\r\n        color: #ffffff!important;\r\n    }\r\n\r\n    .bg-success > .fa-envelope{\r\n        color: #ffffff!important;\r\n    }\r\n\r\n    .drop-disabled {\r\n        color: silver;\r\n    }\r\n</style>\r\n<div class=\"action-buttons\">\r\n    <div class=\"btn-group\">\r\n        <div class=\"pull-left ")
    ; __append(escapeFn(showButtonMenu))
    ; __append("\">\r\n            <div class=\"btn-group\">\r\n                ")
    ; if( optionName != 'notification'){
    ; __append("\r\n                    ")
    ; if (optionName === "settings"){
    ; __append("\r\n                        ")
    ; if (typeUsr !=='1'){
    ; __append("\r\n                        <button type=\"button\" class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\r\n                            New <span class=\"caret\"></span>\r\n                        </button>\r\n                        ")
    ; }
    ; __append("\r\n                    ")
    ; }else{
    ; __append("\r\n                        <button type=\"button\" class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\r\n                            New <span class=\"caret\"></span>\r\n                        </button>\r\n                    ")
    ; }
    ; __append("\r\n                ")
    ; }
    ; __append("\r\n                <ul class=\"dropdown-menu\">\r\n                    ")
    ; 
                    if (this.model.get('selectedTab') === "settings" && uS.getUserType()!=='1'){
    ; __append("\r\n                        ")
    ; if(u.isTrue(uS.checkPermissions("users"))){
    ; __append("\r\n                            <li><a id=\"user\" name=\"user\">User</a></li>\r\n                            <li><a id=\"user-group\" name=\"user-group\">User Group</a></li>\r\n                            <li><a id=\"position\" name=\"position\">Position</a></li>\r\n                        ")
    ; }
    ; __append("\r\n                        ")
    ; if(u.isTrue(uS.checkPermissions("account"))){
    ; __append("\r\n                            <li><a id=\"list\" name=\"list\">List</a></li>\r\n                            <li><a id=\"email-server\" name=\"email-server\">Email Server</a></li>\r\n                        ")
    ; }
    ; __append("\r\n                    ")
    ; }
                    if (this.model.get('selectedTab') === "connections"){
                        if (u.isTrue(uS.checkFeatures("DBConnection"))){
    ; __append("\r\n                    <li><a id=\"database\" name=\"database\">Database Connection</a></li>\r\n                    <li><a id=\"directory-service\" name=\"user-group\">Directory Service Connection</a></li>\r\n                    ")
    ; }
    ; __append("\r\n                    ")
    ; if (enableWSSource){
    ; __append("\r\n                    <li><a id=\"web-service\" name=\"web-service\">SOAP Web Service Connection</a></li>\r\n                    <li><a id=\"rest-web-service\" name=\"rest-web-service\">REST Web Service Connection</a></li>\r\n                    ")
    ; }
    ; __append("\r\n                    <li><a id=\"form-connection\" name=\"form-connection\">App Connection</a></li>\r\n                    ")
    ; 
                        if (u.isTrue(uS.checkFeatures("DBConnection"))){
    ; __append("\r\n                    <li><a id=\"text-file\" name=\"text-file\">Text File Connection</a></li>\r\n                    ")
    ; }
    ; __append("\r\n                    ")
    ; if (u.isTrue(uS.checkFeatures("GoogleSpreadsheet"))){
    ; __append("\r\n                    <li><a id=\"google-spreadsheet\" name=\"google-spreadsheet\">Google Sheets Connection</a></li>\r\n                    ")
    ; }
    ; __append("\r\n                    <li><a id=\"vectordb\" name=\"vectordb\">Vector Database Connection</a></li>\r\n                    \r\n                    ")
    ; }else{
                          if(u.isTrue(uS.checkPermissions(optionName))){
                              var personalFolderGroupTypeId = optionName === 'App' ? '11' : '13';
                              var accountFolderGroupTypeId = optionName === 'App' ? '10' : '12';
                    
    ; __append("\r\n                              <li><a id=\"createNew\" name=\"createNew\">")
    ; __append(escapeFn(optionName))
    ; __append("</a></li>\r\n                              <li class=\"dropdown-submenu user-list-view hide\">\r\n                                  <a tabindex=\"-1\" href=\"#\">Folder</a>\r\n                                  <ul class=\"dropdown-menu\">\r\n                                      <li class=\"li-disabled\"><a tabindex=\"-1\" id=\"createPersonalFolder\" name=\"createPersonalFolder\" data-group-type=\"")
    ; __append(escapeFn( personalFolderGroupTypeId ))
    ; __append("\"  data-group-parent=\"default\">Personal</a></li>\r\n                                      <li class=\"li-disabled\"><a id=\"createAccountFolder\" name=\"createAccountFolder\" data-group-type=\"")
    ; __append(escapeFn( accountFolderGroupTypeId))
    ; __append("\" data-group-parent=\"default\">Account</a></li>\r\n                                  </ul>\r\n                              </li>\r\n                       ")
    ;  }
                        // PF-4406
                        if (this.model.get('currentActiveSection') !== 'settingsSections') { 
    ; __append("\r\n                            <li class=\"li-disabled user-list-private\"><a id=\"createFolder\" name=\"createFolder\">Folder</a></li>\r\n                    ")
    ;  } 
    ; __append("\r\n                   ")
    ; }
    ; __append("\r\n                </ul>\r\n            </div>\r\n        </div>\r\n        <div class=\"pull-right\">\r\n            ")
    ;  if ( optionName !== "Report" ) { 
    ; __append("\r\n                ")
    ;  if ( u.isTrue(uS.checkPermissions(optionName)) ) { 
    ; __append("\r\n                    <button id='import' class=\"btn btn-default hvr-glow\">Import</button>\r\n                ")
    ; }
    ; __append("\r\n            ")
    ; }else{
    ; __append("\r\n                ")
    ;  if ( (!isBULicense && u.isTrue(uS.checkPermissions(optionName))) || enableReports ) { 
    ; __append("\r\n                    <button id='import' class=\"btn btn-default hvr-glow\">Import</button>\r\n                ")
    ; }
    ; __append("\r\n            ")
    ; }
    ; __append("\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n\r\n<div class=\"search-box\">\r\n    <form class=\"\" role=\"search\">\r\n        <div class=\"form-group\">\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"Search\" id=\"formReportSearch\">\r\n        </div>\r\n    </form>\r\n</div>\r\n\r\n\r\n<div class=\"dashboard-left-rail-scroll\">\r\n    <!--.document-group-->\r\n    <div class=\"document-group\">\r\n        <!-- TODO:  also change the SalesFoce feature for the webService feature when ready in admin panel -->\r\n        ")
    ; 
        var perDetails=this.model.get('perDetails');
        if ((perDetails && this.model.get('selectedTab') === "settings") && (uS.getUserType()==='1'
               || (!u.isTrue(uS.checkPermissions('users')) && !u.isTrue(uS.checkPermissions('account'))))) {
        
    ; __append("\r\n            <div class=\"document-items dashboard\">\r\n                <div class=\"bo-heading bg-success\" data-nodetype=\"")
    ; __append(escapeFn(perDetails.nodeType))
    ; __append("\" data-groupid=\"")
    ; __append(escapeFn(perDetails.id))
    ; __append("\">\r\n                    <h5 role=\"button\" data-toggle=\"collapse\">\r\n                        <i class=\"pf-folder\"></i>\r\n                        ")
    ; __append(escapeFn(perDetails.nodeName))
    ; __append("\r\n                    </h5>\r\n                </div>\r\n            </div>\r\n        ")
    ;  }else{
    ; __append("\r\n")
    ; 
        var itemCount = 0;
        var active = "active";
        var headerCollapsedClass= '';
        var nodeCollapsable = '';

        _.forEach(sections, function(section) {
            nodeCollapsable = "collapse";
            headerCollapsedClass = "collapsed";

            if (section.nodeType.toLowerCase() === constants.CONNECTIONS_GOOGLE_SECTION && !u.isTrue(uS.checkFeatures('GoogleSpreadsheet'))) {
                itemCount++;
                headerCollapsedClass = '';
                nodeCollapsable = '';
            }

            if((section.nodeType === 'editForms' && !u.isTrue(uS.checkPermissions('App'))) ||
            (section.nodeType === 'editReports' && !u.isTrue(uS.checkPermissions('Report'))) ||
            (section.nodeType === 'failedNotifications' && !u.isTrue(uS.checkPermissions('failedNotification'))) ||
            (section.nodeType === 'databases' && !u.isTrue(uS.checkFeatures('DBConnection'))) ||
            (section.nodeType === 'directory' && !u.isTrue(uS.checkFeatures('DBConnection'))) ||
            (section.nodeType === 'text' && !u.isTrue(uS.checkFeatures('DBConnection'))) ||
            (section.nodeType === 'web' && !enableWSSource) ||
            (section.nodeType === 'rest' && !enableWSSource) ||
            (section.nodeType === 'google' && !u.isTrue(uS.checkFeatures('GoogleSpreadsheet'))) ||
            (section.nodeType === 'library' && (!u.isTrue(uS.checkPermissions('libraryEnabled')) || !u.isTrue(uS.checkPermissions('App'))))){
                return;
            }

            itemCount++;
            if (itemCount > 1) { active = ""; }
        
    ; __append("\r\n            <div class=\"document dashboard ")
    ; __append(escapeFn(active))
    ; __append("\" >\r\n                <div class=\"document-heading ")
    ; __append(escapeFn(headerCollapsedClass))
    ; __append("\" data-toggle=\"")
    ; __append(escapeFn(nodeCollapsable))
    ; __append("\" data-target=\"#well_")
    ; __append(escapeFn(itemCount))
    ; __append("\" data-nodetype=\"")
    ; __append(escapeFn(section.nodeType))
    ; __append("\" data-itemid=\"")
    ; __append(escapeFn(section.id))
    ; __append("\" data-groupType=\"")
    ; __append(escapeFn(section.groupType))
    ; __append("\">\r\n                    <h4 class=\"document-title\">\r\n                        <a role=\"button\" class=\"\" data-nodetype=\"")
    ; __append(escapeFn(section.nodeType))
    ; __append("\" data-itemid=\"")
    ; __append(escapeFn(section.id))
    ; __append("\" data-groupType=\"")
    ; __append(escapeFn(section.groupType))
    ; __append("\" data-target=\"#well_")
    ; __append(escapeFn(itemCount))
    ; __append("\">\r\n                            ")
    ; __append(escapeFn(section.sectionName))
    ; __append("</a>\r\n                    </h4>\r\n                    ")
    ;  if(section.nodeType!=='failedNotifications'){
    ; __append("\r\n                        <a section-type=\"")
    ; __append(escapeFn(section.sectionType))
    ; __append("\" role=\"button\"   data-target=\"#well_")
    ; __append(escapeFn(itemCount))
    ; __append("\" data-nodetype=\"")
    ; __append(escapeFn(section.nodeType))
    ; __append("\" data-itemid=\"")
    ; __append(escapeFn(section.id))
    ; __append("\" data-groupType=\"")
    ; __append(escapeFn(section.groupType))
    ; __append("\" class=\"switch \">\r\n                            <i class=\"pf pf-carot-left\" ></i>\r\n                        </a>\r\n                    ")
    ;  } 
    ; __append("\r\n                </div>\r\n                <div id=\"well_")
    ; __append(escapeFn(itemCount))
    ; __append("\" class=\"document-body ")
    ; __append(escapeFn(nodeCollapsable))
    ; __append("\">\r\n                    ")
    ; 
                    if (section.nodes) {
                        _.forEach(section.nodes, function(node) {
                            if (((node.nodeName.toLowerCase()==='license' || node.nodeName.toLowerCase()===  'account details') && u.isTrue(uS.checkPermissions("account")))
                            || (node.nodeName.toLowerCase()!=='license' && node.nodeName.toLowerCase()!==  'account details') ){
                              
                    
    ; __append("\r\n                            <div class=\"document-items dashboard\">\r\n                                    \r\n                               <div class=\"bo-heading\" data-nodetype=\"")
    ; __append(escapeFn(node.nodeType))
    ; __append("\" data-groupid=\"")
    ; __append(escapeFn(node.id))
    ; __append("\">\r\n                                   <h5 role=\"button\" data-toggle=\"collapse\">\r\n                                       <i class=\"pf-folder\"></i>\r\n                                       ")
    ; __append(escapeFn(node.nodeName))
    ; __append("\r\n                                   </h5>                                                                 \r\n                               </div>                            \r\n                            </div>\r\n                        ")
    ; 
                          }
                        });
                    }

                    if (section.groups) {
                        _.forEach(section.groups, function(group) {
                            itemCount++;

                           if(((group.groupName.toLowerCase() === 'resources' && u.isTrue(uS.checkPermissions("account")))
                            || (group.groupName.toLowerCase() !== 'resources')) && 
                            ((group.groupName.toLowerCase() === 'users' && u.isTrue(uS.checkPermissions("users")))
                            || (group.groupName.toLowerCase() !== 'users'))
                        ){
                      
    ; __append("\r\n                            <div class=\"document-items dashboard\">\r\n                                <div ")
    ; if(group.nodeType === 'SharedForms'){
    ; __append(" id=\"canDropForms\" ")
    ; }
    ; __append(" class=\"bo-heading droppableContainer\" data-nodetype=\"")
    ; __append(escapeFn(group.nodeType))
    ; __append("\" data-groupid=\"")
    ; __append(escapeFn(group.id))
    ; __append("\">\r\n                                    <h5 role=\"button\" data-toggle=\"collapse\" data-target=\"#well_")
    ; __append(escapeFn(itemCount))
    ; __append("\">\r\n                                        <i class=\"pf-folder\"></i>\r\n                                        ")
    ; __append(escapeFn(group.groupName))
    ; __append("\r\n                                    </h5>\r\n                                    <a role=\"button\" data-toggle=\"collapse\" data-target=\"#well_")
    ; __append(escapeFn(itemCount))
    ; __append("\" class=\"switch collapsed\">\r\n                                        <i class=\"pf pf-carot-left\"></i>\r\n                                    </a>\r\n                                </div>\r\n                                <div id=\"well_")
    ; __append(escapeFn(itemCount))
    ; __append("\" class=\"bo-body collapse\">\r\n                                    <ul class=\"group-items\">\r\n                                        ")
    ; 
                                         if (group.nodes) {
                                            _.forEach(group.nodes, function(node) {
                                          
    ; __append("\r\n                                            <li role=\"button\" data-toggle=\"collapse\" data-target=\"#well_")
    ; __append(escapeFn(node.id))
    ; __append("\" class=\"switch collapsed\" data-itemid=\"")
    ; __append(escapeFn(node.id))
    ; __append("\">\r\n                                                <a href=\"#\" role=\"\">\r\n                                                    ")
    ; __append(escapeFn(node.nodeName))
    ; __append("\r\n                                                </a>\r\n                                            </li>\r\n                                        ")
    ;  if (node.hasChildren) {
    ; __append("\r\n                                             <div id=\"well_")
    ; __append(escapeFn(node.id))
    ; __append("\" class=\"bo-body collapse\">\r\n                                                 <ul class=\"group-items\"></ul>\r\n                                             </div>\r\n                                        ")
    ; 
                                            }
                                         });
                                        };
                                        
    ; __append("\r\n                                    </ul>\r\n                                </div>\r\n                            </div>\r\n                        ")
    ; 
                        }
                    });
                    }
    ; __append("\r\n                </div>\r\n            </div>\r\n        ")
    ;  });} 
    ; __append("\r\n    </div>\r\n\r\n<div id=\"trial-status\"> </div>\r\n\r\n</div>\r\n")
  }
  return __output;

}